<template>
    <section class="home">
        <HomeHero/>
        <HomeStart/>
        <HomeAbout/>
        <HomeAllubum/>
        <HomeChat/>
    </section>
</template>

<script>
import HomeHero from './HomeHero.vue'
import HomeChat from './HomeChat.vue'
import HomeAllubum from './HomeAllubum.vue'
import HomeAbout from './HomeAbout.vue'
import HomeStart from './HomeStart.vue'



export default {
    name: 'Home',
    components: {
        HomeHero,
        HomeStart,
        HomeAbout,
        HomeAllubum,
        HomeChat,
    },
}
</script>

<style lang="scss" scoped>
.home {
    padding-bottom: 50px;
}
</style>